import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiChevronDown, FiCheck, FiMapPin} = FiIcons;

const brookhavenMapUrl = 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3348.8237120541803!2d-96.85265362449772!3d32.929255576190705!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864c272414eacf6f%3A0x2e46190b48ff20c!2sDallas%20College%20Brookhaven%20Campus!5e0!3m2!1sen!2sus!4v1790266167743!5m2!1sen!2sus';

function ProgramAccordion({program, isOpen, onToggle}) {
  const mapUrl = program.name === 'Dallas College Brookhaven Campus'
    ? brookhavenMapUrl
    : program.mapEmbedUrl;

  return (
    <article className={`program-card ${isOpen ? 'open' : ''}`}>
      <button
        className="program-trigger"
        onClick={onToggle}
        aria-expanded={isOpen}
        aria-controls={`program-details-${program.name}`}
      >
        <span>
          <strong>{program.name}</strong>
          <small>{program.badge}</small>
        </span>
        <SafeIcon icon={FiChevronDown} className="chevron" aria-hidden="true" />
      </button>

      <motion.div
        className="program-content"
        id={`program-details-${program.name}`}
        initial={false}
        animate={{
          height: isOpen ? 'auto' : 0,
          opacity: isOpen ? 1 : 0,
        }}
        transition={{duration: 0.3, ease: 'easeInOut'}}
        style={{overflow: 'hidden'}}
      >
        <div className="program-inner">
          <p className="program-summary">{program.summary}</p>

          <div
            className="spec-table"
            role="table"
            aria-label={`${program.name} details`}
          >
            {program.specs.map(([label, value]) => (
              <div className="spec-row" role="row" key={label}>
                <span role="cell">{label}</span>
                <strong role="cell">{value}</strong>
              </div>
            ))}
          </div>

          {program.paragraphs.map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}

          <ul className="highlight-list">
            {program.highlights.map((item) => (
              <li key={item}>
                <SafeIcon icon={FiCheck} />
                {item}
              </li>
            ))}
          </ul>

          <div className="location-title">
            <SafeIcon icon={FiMapPin} />
            <span>{program.address}</span>
          </div>

          <iframe
            className="map"
            src={mapUrl}
            width="600"
            height="450"
            style={{border: 0}}
            title={`Google Maps location for ${program.name}`}
            allowFullScreen
            loading="lazy"
            referrerPolicy="strict-origin-when-cross-origin"
          />
        </div>
      </motion.div>
    </article>
  );
}

export default ProgramAccordion;